export default __webpack_public_path__ + "static/media/Total.efc003fe.svg";